import { ACCOUNT_GROUP_TYPE, AccountType, CardStatus } from '@zeusm/personal/core/entities';

import { GetAccountsRes } from '../models';

export const getAccountsResMock: GetAccountsRes = {
  fiatAccounts: [
    {
      id: '01990ae6-3051-9be8-23af-0228b2cdea48',
      currencyId: 'fb3bfa07-1574-46b6-8a5f-00fd9ef187c8',
      balance: '140050',
      type: ACCOUNT_GROUP_TYPE.CLIENT,
      accountType: AccountType.FiatWallet,
      status: 'Active',
      createdAt: '2025-09-02T14:48:01.87502Z',
      updatedAt: '2025-09-02T14:48:01.87502Z',
      card: null,
      cardProduct: null,
    },
    {
      id: '01990ae7-ea5e-11b6-47b9-c9e409a3052b',
      currencyId: '7cdc2c0a-7b55-47bb-baaa-ce82cb3de55c',
      balance: '77083',
      type: ACCOUNT_GROUP_TYPE.CLIENT,
      accountType: AccountType.FiatWallet,
      status: 'Active',
      createdAt: '2025-09-02T14:49:55.039338Z',
      updatedAt: '2025-09-02T14:49:55.039338Z',
      card: null,
      cardProduct: null,
    },
  ],
  cryptoAccounts: [
    {
      id: '01dddde6-3051-9be8-23af-0228b2cdea48',
      currencyId: 'fb3bf777-1574-46b6-8a5f-00fd9ef187c8',
      balance: '0,0000091',
      type: ACCOUNT_GROUP_TYPE.CLIENT,
      accountType: AccountType.CryptoWallet,
      status: 'Active',
      createdAt: '2025-09-02T14:48:01.87502Z',
      updatedAt: '2025-09-02T14:48:01.87502Z',
      card: null,
      cardProduct: null,
    },
    {
      id: '01dddde6-3051-9be8-23af-0228b2cdea49',
      currencyId: 'fb3bf777-1574-46b6-8a5f-00fd9ef187c8',
      balance: '0,00091',
      type: ACCOUNT_GROUP_TYPE.CLIENT,
      accountType: AccountType.CryptoWallet,
      status: 'Active',
      createdAt: '2025-09-02T14:48:01.87502Z',
      updatedAt: '2025-09-02T14:48:01.87502Z',
      card: null,
      cardProduct: null,
    },
  ],
  cardAccounts: [
    {
      id: '019a3993-e1ab-0ced-28f4-b266c570333b',
      currencyId: '7cdc2c0a-7b55-47bb-baaa-ce82cb3de55c',
      balance: '0',
      type: 'Client',
      status: 'Active',
      createdAt: '2025-10-31T09:23:04.237606Z',
      updatedAt: '2025-10-31T09:23:04.237606Z',
      card: {
        id: '019a3993-e1ec-9bcd-9bd8-b9fffe9923c9',
        pan: '516300****2157',
        status: CardStatus.Suspended,
        createdAt: '2025-10-31T09:23:04.300925Z',
        cardHolder: 'JOHN DOE',
      },
      cardProduct: {
        id: 'e257edfb-d382-421e-a252-e1da8cd1c4f1',
        brand: 'Mastercard',
        bin: 53996730,
        dailyVolumeLimit: '0',
        monthlyVolumeLimit: '5000',
      },
    },
  ],
};
